import React from 'react';
import PropTypes from 'prop-types';
import { Badge, Avatar, Icon } from '@blend-ed/blendx-ui';
import { format } from 'date-fns';
import { useIntl } from '@edx/frontend-platform/i18n';
import messages from './messages';

const TicketHeader = ({ ticket }) => {
    const intl = useIntl();

    const formatDate = (dateString) => {
        return format(new Date(dateString), 'MMM dd, yyyy');
    };

    return (
        <div className="view-ticket__ticket-info">
            <div className="view-ticket__ticket-header">
                <div className="view-ticket__ticket-id-status">
                    <span className="view-ticket__ticket-id">#{ticket.id.split('-')[0]}</span>
                    <Badge variant="primary" className="view-ticket__status-badge">
                        {ticket.status}
                    </Badge>
                    {ticket.priority && (
                        <Badge variant="warning" className="view-ticket__priority-badge">
                            {ticket.priority}
                        </Badge>
                    )}
                </div>

                <div>
                    <h1 className="view-ticket__ticket-title">{ticket.title}</h1>
                    <p className="view-ticket__ticket-description">{ticket.description}</p>
                </div>
            </div>

            <div className="view-ticket__assigned-to">
                <div className="view-ticket__assigned-to-person">
                    <div className="view-ticket__assigned-person">
                        <span>{intl.formatMessage(messages.assignedTo)}:</span>
                    </div>
                    <span>{ticket.assignedTo.name ? "Support Staff" : 'N/A'}</span>
                </div>
                <div className="view-ticket__assigned-to-time">
                    <Icon icon="time" type="line" size="sm" />
                    <span>{formatDate(ticket.createdAt)}</span>
                </div>
            </div>
        </div>
    );
};

TicketHeader.propTypes = {
    ticket: PropTypes.shape({
        id: PropTypes.string.isRequired,
        status: PropTypes.string.isRequired,
        priority: PropTypes.string,
        title: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        assignedTo: PropTypes.shape({
            name: PropTypes.string.isRequired,
            avatar: PropTypes.string
        }).isRequired,
        createdAt: PropTypes.string.isRequired
    }).isRequired
};

export default TicketHeader; 